var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"modal-closer",on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_c('img',{attrs:{"src":_vm.src,"alt":"close"}})])}
var staticRenderFns = []

export { render, staticRenderFns }